import React from "react";
import { Box, Skeleton, Divider, Stack } from "@mui/joy";

export function InitialInspectionSkeleton() {
    return (
        <Box sx={{ display: "flex", flexDirection: "column", mt: 1, gap: 3 }}>
            {/* Header Area */}
            <Box sx={{ display: "flex", gap: 2, alignItems: "center", mb: 2 }}>
                <Skeleton variant="circular" width={40} height={40} />
                <Box sx={{ flex: 1 }}>
                    <Skeleton variant="text" width="20%" height={20} sx={{ mb: 1 }} />
                    <Skeleton variant="text" width="40%" height={30} />
                </Box>
            </Box>

            <Divider />

            {/* Sections */}
            {[1, 2, 3, 4, 5].map((i) => (
                <Box key={i}>
                    <Skeleton variant="text" width="30%" height={28} sx={{ mb: 1 }} />
                    <Skeleton variant="text" width="50%" height={20} sx={{ mb: 2 }} />
                    <Stack spacing={2}>
                        <Box display="flex" gap={2}>
                            <Skeleton variant="rectangular" width="30%" height={40} />
                            <Skeleton variant="rectangular" width="30%" height={40} />
                            <Skeleton variant="rectangular" width="30%" height={40} />
                        </Box>
                        <Skeleton variant="rectangular" width="100%" height={40} />
                    </Stack>
                    {i < 5 && <Divider sx={{ mt: 3 }} />}
                </Box>
            ))}
        </Box>
    );
}
